import axios from 'axios';
import config from '../config';

const API_URL = config.API_BASE_URL;

// Get all wallets
export const fetchWallets = async () => {
  const response = await axios.get(`${API_URL}/Wallets`);
  return response.data;
};

// Get single wallet
export const fetchWalletById = async (id) => {
  const response = await axios.get(`${API_URL}/Wallets/${id}`);
  return response.data;
};

// Create wallet (Admin only)
export const createWallet = async (walletData) => {
  const response = await axios.post(`${API_URL}/Wallets`, walletData);
  return response.data;
};

// Update wallet (Admin only)
export const updateWallet = async (id, walletData) => {
  const response = await axios.put(`${API_URL}/Wallets/${id}`, walletData);
  return response.data;
};

// Delete wallet (Admin only)
export const deleteWallet = async (id) => {
  const response = await axios.delete(`${API_URL}/Wallets/${id}`);
  return response.data;
};

// Get wallets for a specific branch
export const fetchBranchWallets = async (branchId) => {
  const response = await axios.get(`${API_URL}/Wallets/branch/${branchId}`);
  return response.data;
};

// Assign wallet to branch
export const assignWalletToBranch = async (branchId, walletId, walletNumber, walletAccountName = null) => {
  const response = await axios.post(`${API_URL}/Wallets/assign`, {
    branchId,
    walletId,
    walletNumber,
    walletAccountName
  });
  return response.data;
};

// Unassign wallet from branch
export const unassignWalletFromBranch = async (branchId, walletId) => {
  const response = await axios.post(`${API_URL}/Wallets/unassign`, {
    branchId,
    walletId
  });
  return response.data;
};

// Update wallet number for a branch
export const updateBranchWalletNumber = async (branchId, walletId, walletNumber = null, walletAccountName = null) => {
  const payload = {
    branchId,
    walletId
  };
  
  // Only include fields that are provided
  if (walletNumber !== null && walletNumber !== undefined) {
    payload.walletNumber = walletNumber;
  }
  
  if (walletAccountName !== null && walletAccountName !== undefined) {
    payload.walletAccountName = walletAccountName;
  }
  
  const response = await axios.put(`${API_URL}/Wallets/update-number`, payload);
  return response.data;
};

// Update wallet information for a branch (alternative naming for clarity)
export const updateBranchWalletInfo = async (branchId, walletId, updates = {}) => {
  const payload = {
    branchId,
    walletId,
    ...updates // Can include walletNumber and/or walletAccountName
  };
  
  const response = await axios.put(`${API_URL}/Wallets/update-number`, payload);
  return response.data;
};